var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc110(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "11.9012mm",
    height: "7.5935mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 1241.94 792.42",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2465255677264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M972.44 792.42l-702.67 0 0 -792.42 702.67 0 0 792.42zm-679.47 -23.2l656.28 0 0 -746.02 -656.28 0 0 746.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M897.06 374.4l-256.22 0 0 -297.92 256.22 0 0 297.92zm-233.02 -23.2l209.84 0 0 -251.53 -209.84 0 0 251.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M897.06 715.93l-256.22 0 0 -297.91 256.22 0 0 297.91zm-233.02 -23.47l209.84 0 0 -250.69 -209.84 0 0 250.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M601.36 374.4l-256.49 0 0 -297.92 256.49 0 0 297.92zm-233.31 -23.2l210.12 0 0 -251.53 -210.12 0 0 251.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M601.36 715.93l-256.49 0 0 -297.91 256.49 0 0 297.91zm-233.31 -23.47l210.12 0 0 -250.69 -210.12 0 0 250.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M1109.94 692.18l-15.74 -17.11c79.18,-70.98 124.58,-172.46 124.58,-278.86 0,-106.41 -45.39,-207.88 -124.6,-278.87l15.74 -17.4c83.99,75.5 132.02,183.16 132.02,296.13 0,112.95 -48.02,220.62 -132.02,296.1l0.02 0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M1209.61 695.22l-119.28 0 0 -119.27 23.47 0 0 96.08 95.81 0 0 23.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M132.27 692.18c-84.12,-75.35 -132.27,-183.11 -132.27,-296.11 0,-113.01 48.15,-220.76 132.27,-296.14l15.47 17.4c-79.18,70.99 -124.58,172.47 -124.58,278.88 0,106.4 45.39,207.87 124.6,278.85l-15.49 17.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M151.6 216.47l-23.2 0 0 -96.09 -96.08 0 0 -23.19 119.28 0 0 119.28z"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc110);
export default __webpack_public_path__ + "static/media/ic_1_10.af6dd27024fa80a3a6ecd8ad6ef43bd4.svg";
export { ForwardRef as ReactComponent };